export default __webpack_public_path__ + "static/media/Monochrome-1613437789625.63150d37.png";